export default {
  agentById: (state) => (id) => state.agents.find((a) => a.id === id),
  isPermissionsLoading: (_, getters) => (id) => getters.agentById(id).isLoading,
  agentPermissions: (_, getters) => (id) => getters.agentById(id).permissions,
};
